// Module
var code = `<div class="flex justify-end placeholder-subheader"> </div>`;
// Exports
module.exports = code;